<template>
  <span ref="number" :id="countId"></span>
</template>
<script>
import {
  defineComponent,
  ref,
  onMounted,
  computed,
  reactive,
  watch,
} from 'vue';
import CountUp from 'countup';
import { v4 as uuid } from 'uuid';
import { useSiteStore } from '@/store/site';

export default defineComponent({
  name: 'CountTo',

  props: {
    startVal: {
      type: Number,
      default: 0,
    },
    endVal: {
      type: Number,
      required: true,
    },
    decimals: {
      type: Number,
      default: 0,
    },
    delay: {
      type: Number,
      default: 0,
    },
    duration: {
      type: Number,
      default: 1,
    },
    useEasing: {
      type: Boolean,
      default: false,
    },
    useGroup: {
      type: Boolean,
      default: true,
    },
    separator: {
      type: String,
      default: ',',
    },
    decimal: {
      type: String,
      default: '.',
    },
    className: {
      type: String,
      default: '',
    },
  },

  setup(props) {
    let isStarted = false;
    const siteStore = useSiteStore();
    const appRoot = computed(() => siteStore.appRoot);
    const number = ref(null);
    const countId = uuid();
    let counter = reactive({});

    const countStart = () => {
      // this.$nextTick(() => {
      counter = new CountUp(countId, props.startVal, props.endVal, props.decimals, props.duration, {
        useEasing: props.useEasing,
        useGroup: props.useGroup,
        separator: props.separator,
        decimal: props.decimal,
      });
      setTimeout(() => {
        counter.start();
      }, props.delay);
      // });
    };

    const handleScroll = () => {
      if (isStarted) return;
      if (!number.value.getBoundingClientRect) return;
      const numberEle = number.value.getBoundingClientRect();
      if (!numberEle) return;
      const windowTopOffset = numberEle.top;
      const threshold = document.body.clientHeight * 0.9; // 距離底部 10% （1-0.9）時出現

      if (threshold > windowTopOffset) {
        isStarted = true;
        countStart();
        document.querySelector('#app').removeEventListener('scroll', handleScroll);
      }
    };

    watch(() => props.endVal, (newVal) => {
      counter.update(newVal);
    });

    onMounted(() => {
      handleScroll();
      appRoot.value.addEventListener('scroll', handleScroll);
    });

    return {
      countId,
      number,
    };
  },
});
</script>
